var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"processItem"},[_c('div',{staticClass:"item info"},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.info)+" ")])]),(_vm.showIcon)?_c('div',{staticClass:"item icon"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }